import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'lib-search-button',
  templateUrl: './search-button.component.html',
})
export class SearchButtonComponent {
  @Input() text: string = '';
  @Input() control: AbstractControl = {} as FormControl;
  @Output() actionEvent = new EventEmitter<boolean>();
  constructor() { }
}
